import { http } from '..';
import type {
  CreateRequestDto,
  GetAllRequestsResponseDto,
  ImportRequestsDto,
  ImportRequestsResponseDto,
  Request,
  UpdateRequestDto,
} from './types';

export const fetchAll = async (
  id: string,
  query: Record<string, string>,
): Promise<GetAllRequestsResponseDto> => {
  return http.query(query).get(`/admin/projects/${id}/requests`).json();
};

export const fetchOne = async (id: string, projectId: string): Promise<Request> => {
  return http.url(`/admin/projects/${projectId}/requests/${id}`).get().json();
};

export const create = async (projectId: string, data: CreateRequestDto) => {
  return http.url(`/admin/projects/${projectId}/requests`).post(data).res();
};

export const update = async (id: string, data: UpdateRequestDto) => {
  return http.url(`/admin/requests/${id}`).put(data).res();
};

export const remove = async (id: string) => {
  return http.url(`/admin/requests/${id}`).delete().res();
};

export const findDuplicates = async (id: string) => {
  return http.url(`/projects/${id}/requests/duplicates/ai`).get().json();
};

export const exportToCsv = async (projectId: string) => {
  const response = await http.url(`/admin/projects/${projectId}/requests/export`).get().res();
  return response.blob();
};

export const importFromCsv = async (
  projectId: string,
  data: ImportRequestsDto,
): Promise<ImportRequestsResponseDto> => {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('mapping', JSON.stringify(data.mapping));

  return http.url(`/admin/projects/${projectId}/requests/import`).body(formData).post().json();
};
